export const MAX_ADDITIONAL_PHOTOS = 5;

export function moveAdditionalPhoto(photos, index, offset) {
  if (!Array.isArray(photos) || !Number.isInteger(index) || !Number.isInteger(offset)) return photos || [];
  const nextIndex = index + offset;
  if (index < 0 || index >= photos.length || nextIndex < 0 || nextIndex >= photos.length) return [...photos];
  const next = [...photos];
  [next[index], next[nextIndex]] = [next[nextIndex], next[index]];
  return next;
}

export function removeAdditionalPhoto(photos, index) {
  if (!Array.isArray(photos) || !Number.isInteger(index) || index < 0 || index >= photos.length) return photos || [];
  return photos.filter((_, photoIndex) => photoIndex !== index);
}

export function appendAdditionalPhoto(photos, photo) {
  const current = Array.isArray(photos) ? photos : [];
  if (current.length >= MAX_ADDITIONAL_PHOTOS) return { photos: current, added: false };
  return { photos: [...current, photo], added: true };
}
